import React, {Fragment, useState, useEffect} from "react";
import {
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormGroup,
    Typography,
    Grid,
    Checkbox,
    Box,
    Tooltip,
    IconButton,
    Paper,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import {v4 as uuidv4} from "uuid";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import {
    pilDetailFormStyle
} from "../../../../styles/jss/components/ProjectInformation/projectInformationDetailFormStyle";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import {getNameList, getProjCodeList} from "../../../../dataSource/pil";
import {
    natureList,
    contractList,
    defectList,
    paymentTermList,
} from "../pilAttributeList/pilAttributeList";
import {FormControl} from "@mui/material";

const useStyles = makeStyles((theme) => pilDetailFormStyle(theme));
const PilProjectData = (props) => {
    const classes = useStyles();
    const [nameList, setNameList] = useState([]);
    const [projCodeList, setProjCodeList] = useState([]);
    let {editable, pilDetails, setPilDetails, htmlStr, error, setError} = props;
    const [enableProjPhasing, setEnableProjPhasing] = useState(
        pilDetails.sics.length > 0 && pilDetails.sics[0].proj_phasing ? true : false
    );
    const nature = natureList;
    const contract = contractList;
    const defect = defectList;
    const paymentTerm = paymentTermList;
    const addPhasedOP = () => {
        let data = {...pilDetails};
        let addBody = {
            id: uuidv4(),
            pil_seq: pilDetails.general.pil_seq,
            target_date: null,
            actual_date: null,
            status: "Y",
        };
        data.phaseOp = [...data.phaseOp, addBody];
        setPilDetails({...pilDetails, ...data});
    };
    const addAAWorks = () => {
        let data = {...pilDetails};
        let addBody = {
            pil_seq: pilDetails.general.pil_seq,
            description: "",
        };
        data.natures.aaworks = [...data.natures.aaworks, addBody];
        setPilDetails({...pilDetails, ...data});
    };

    const handleAAChanges = (index) => (event) => {
        let data = {...pilDetails};
        data["natures"]["aaworks"][index]["description"] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };
    const handleOtherConsultantChange = (index, name) => (event) => {
        let data = {...pilDetails};
        data["otherConsultant"][index][name] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };

    const handlePersonChange = (event, index, module, name, value) => {
        let data = {...pilDetails};
        data[module][index][name] = value;
        if (name !== "orcl_code" && name !== "orcl_sub_code") {
            data[module][index]["login_id"] = nameList && nameList.filter((obj) => obj.fullname === value)[0]?.login_id;
            data[module][index]["staff_id"] = nameList && nameList.filter((obj) => obj.fullname === value)[0]?.staff_id;
            data[module][index]["english_name"] = nameList && nameList.filter((obj) => obj.fullname === value)[0]?.english_name;
            data[module][index]["position"] = nameList && nameList.filter((obj) => obj.fullname === value)[0]?.position;
        }
        setPilDetails({...pilDetails, ...data});
    };
    const deleteItems = (index, module) => {
        let data = {...pilDetails};
        data[module].splice(index, 1);
        setPilDetails({...pilDetails, ...data});
    };
    const deleteAAItems = (index) => {
        let data = {...pilDetails};
        data.natures.aaworks.splice(index, 1);
        setPilDetails({...pilDetails, ...data});
    };
    const addOtherConsultant = () => {
        let data = {...pilDetails};
        let addBody = {
            pil_seq: pilDetails.general.pil_seq,
            title: "",
            name: "",
        };
        data.otherConsultant = [...data.otherConsultant, addBody];
        setPilDetails({...pilDetails, ...data});
    };
    const addPerson = (name) => {
        let data = {...pilDetails};
        let addBody = {
            pil_seq: pilDetails.general.pil_seq,
            login_id: "",
            staff_id: "",
            full_name: "",
            english_name: "",
            position: ""
        };
        if (name === "sics") {
            addBody.proj_phasing = "";
            addBody.orcl_code = "";
            console.log(addBody)
        }
        if (name === "cpms") {
            addBody.email = "";
        }
        data[name] = [...data[name], addBody];
        setPilDetails({...pilDetails, ...data});
    };
    const addSecCom = () => {
        let data = {...pilDetails};
        let addBody = {
            id: uuidv4(),
            pil_seq: pilDetails.general.pil_seq,
            target_date: null,
            actual_date: null,
            status: "Y",
        };
        data.secCom = [...data.secCom, addBody];
        setPilDetails({...pilDetails, ...data});
    };
    const deleteDates = (module, id) => {
        let data = {...pilDetails};
        let index = data[module].findIndex((obj) => obj.id === id);
        data[module][index]["status"] = "N";
        setPilDetails({...pilDetails, ...data});
    };
    const handleNature = (code) => {
        let data = {...pilDetails};
        if (pilDetails.natures.nature.indexOf(code) === -1) {
            data.natures.nature = [...data.natures.nature, code];
        } else {
            data.natures.nature.splice(data.natures.nature.indexOf(code), 1);
        }
        setPilDetails({...pilDetails, ...data});
    };
    const handleCheckBox = (module, code) => {
        let data = {...pilDetails};
        data[module][code] = data[module][code] === "Y" ? "N" : "Y";
        if (module === "paymentTerm" && code === "ARCH") {
            data[module]["PERIOD"] = "";
        }
        setPilDetails({...pilDetails, ...data});
        if (module === "contract") {
            if (data[module][code] === "N") {
                let data = [...error];
                let index = error.indexOf(code);
                data.splice(index, 1);
                setError(data);
            }
            if (data[module][code] === "Y" && getCostPlus(code) === "") {
                if (error.indexOf(code) === -1) {
                    setError([...error, code]);
                }
            }
        }
    };

    const handleContractOtherChange = (event) => {
        let data = {...pilDetails};
        data["contract"]["OTHERSREMARK"] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };
    const handlePeriodChange = (event) => {
        let data = {...pilDetails};
        data["paymentTerm"]["PERIOD"] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };
    const handleSicChange = (index, module, name) => (event) => {
        let data = {...pilDetails};
        data[module][index][name] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };

    const handleContractInputChange = (code) => (event) => {
        let data = {...pilDetails};
        let name = code === "INHOUSE" ? "INCOST" : "JVCOST";
        data["contract"][name] = event.target.value;
        setPilDetails({...pilDetails, ...data});
        if (data["contract"][code] === "Y" && event.target.value === "") {
            console.log(code)
            setError([...error, code]);
        } else {
            let data = [...error];
            let index = error.indexOf(code);
            data.splice(index, 1);
            setError(data);
        }
    };
    const handleInputChange = (module, name) => (event) => {
        let data = {...pilDetails};
        data[module][name] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };
    const handleAddedDateFieldChange = (date, module, id, name) => {
        let data = {...pilDetails};
        let index = data[module].findIndex((obj) => obj.id === id);
        data[module][index][name] = date;
        setPilDetails({...pilDetails, ...data});
    };
    const handleDateFieldChange = (date, name) => {
        let data = {...pilDetails};
        data["details"][name] = date;
        setPilDetails({...pilDetails, ...data});
    };
    const handleRadioChange = (event) => {
        let data = {...pilDetails};
        data["details"]["lot_no_code"] = event.target.value;
        setPilDetails({...pilDetails, ...data});
    };
    const handleDefectRadioChange = (event) => {
        let data = {...pilDetails};
        data["details"]["DEFECT12"] = event.target.value === "DEFECT12" ? "Y" : "N";
        data["details"]["DEFECT3YEARS"] =
            event.target.value === "DEFECT3YEARS" ? "Y" : "N";
        setPilDetails({...pilDetails, ...data});
    };
    const readOnlyAndDisabled = !editable;
    const textfieldVariant = editable ? "outlined" : "standard";

    const fetchProjCode = async () => {
        try {
            const response = await getProjCodeList();
            setProjCodeList(response.data);
        } catch (err) {
            setProjCodeList((prev) => prev);
        }
    };
    const fetchNameList = async () => {
        const response = await getNameList();
        setNameList(response.data);
    };
    useEffect(() => {
        const fetchList = async () => {
            await fetchNameList();
            await fetchProjCode();
        };
        fetchList();
    }, []);
    const getCostPlus = (code) => {
        let costplus = "";
        costplus =
            code === "INHOUSE"
                ? pilDetails.contract.INCOST
                : pilDetails.contract.JVCOST;
        return costplus;
    };
    const disabled = false;
    return (
        <Fragment>
            {editable ? (
                <>
                    <Typography variant="subtitle1" className={classes.editSubHeader}>
                        Project Data:
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"proj_name"}
                                name={"proj_name"}
                                label={"Name of Project"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.general.name || ""}
                                onChange={handleInputChange("general", "name")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"estate"}
                                name={"estate"}
                                label={"Name of Estate/ Development"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.general.estate_name || ""}
                                onChange={handleInputChange("general", "estate_name")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"lot_no"}
                                name={"lot_no"}
                                label={"Lot No."}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.lot_no || ""}
                                onChange={handleInputChange("details", "lot_no")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <RadioGroup
                                row
                                value={pilDetails.details.lot_no_code || ""}
                                onChange={handleRadioChange}
                            >
                                <FormControlLabel
                                    value="HK"
                                    control={<Radio disabled={disabled}/>}
                                    label="HK"
                                />
                                <FormControlLabel
                                    value="KLN"
                                    control={<Radio disabled={disabled}/>}
                                    label="KLN"
                                />
                                <FormControlLabel
                                    value="NT"
                                    control={<Radio disabled={disabled}/>}
                                    label="NT"
                                />
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"GBP"}
                                name={"GBP"}
                                label={"GBP"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.gbp || ""}
                                onChange={handleInputChange("details", "gbp")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        {/*
                                    <Grid item xs={4}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"COP_X"}
                                name={"COP_X"}
                                label={"COP_X"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.cop_x || ""}
                                onChange={handleInputChange("details", "cop_x")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"COP_Y"}
                                name={"COP_Y"}
                                label={"COP_Y"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.cop_y || ""}
                                onChange={handleInputChange("details", "cop_y")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"COP_Z"}
                                name={"COP_Z"}
                                label={"COP_Z"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.cop_z || ""}
                                onChange={handleInputChange("details", "cop_z")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        */}
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"site_area_1"}
                                name={"site_area_1"}
                                label={"Site Area(s.m.)"}
                                type="number"
                                size="small"
                                variant="outlined"
                                value={pilDetails.areas.site_area_1 || ""}
                                onChange={handleInputChange("areas", "site_area_1")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"site_area_1"}
                                name={"site_area_1"}
                                label={"Site Area(s.ft.)"}
                                type="text"
                                size="small"
                                variant="outlined"
                                value={
                                    pilDetails.areas.site_area_1 === ""
                                        ? ""
                                        : Number.parseFloat(
                                            pilDetails.areas.site_area_1 * 10.76391
                                        ).toFixed(2)
                                }
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"gfa_total"}
                                name={"gfa_total"}
                                label={"Gross Floor Area(s.m.)"}
                                type="number"
                                size="small"
                                variant="outlined"
                                value={pilDetails.areas.gfa_total || ""}
                                onChange={handleInputChange("areas", "gfa_total")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"gfa_total"}
                                name={"gfa_total"}
                                label={"Gross Floor Area(s.ft.)"}
                                type="text"
                                size="small"
                                variant="outlined"
                                value={
                                    pilDetails.areas.gfa_total === ""
                                        ? ""
                                        : Number.parseFloat(
                                        pilDetails.areas.gfa_total * 10.76391
                                    ).toFixed(2) || ""
                                }
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"domestic_gfa"}
                                name={"domestic_gfa"}
                                label={"Domestic Gross Floor Area(s.m.)"}
                                type="number"
                                size="small"
                                variant="outlined"
                                value={pilDetails.areas.domestic_gfa || ""}
                                onChange={handleInputChange("areas", "domestic_gfa")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"domestic_gfa"}
                                name={"domestic_gfa"}
                                label={"Domestic Gross Floor Area(s.ft.)"}
                                type="text"
                                size="small"
                                variant="outlined"
                                value={
                                    pilDetails.areas.domestic_gfa === ""
                                        ? ""
                                        : Number.parseFloat(
                                        pilDetails.areas.domestic_gfa * 10.76391
                                    ).toFixed(2) || ""
                                }
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"nondomestic_gfa"}
                                name={"nondomestic_gfa"}
                                label={"Non Domestic Gross Floor Area(s.m.)"}
                                type="number"
                                size="small"
                                variant="outlined"
                                value={pilDetails.areas.nondomestic_gfa || ""}
                                onChange={handleInputChange("areas", "nondomestic_gfa")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"nondomestic_gfa"}
                                name={"nondomestic_gfa"}
                                label={"Non Domestic Gross Floor Area(s.ft.)"}
                                type="text"
                                size="small"
                                variant="outlined"
                                value={
                                    pilDetails.areas.nondomestic_gfa === ""
                                        ? ""
                                        : Number.parseFloat(
                                        pilDetails.areas.nondomestic_gfa * 10.76391
                                    ).toFixed(2) || ""
                                }
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"cfa_total"}
                                name={"cfa_total"}
                                label={"Construction Floor Area(s.m.)"}
                                type="number"
                                size="small"
                                variant="outlined"
                                value={pilDetails.areas.cfa_total || ""}
                                onChange={handleInputChange("areas", "cfa_total")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"cfa_total"}
                                name={"cfa_total"}
                                label={"Construction Floor Area(s.ft.)"}
                                type="text"
                                size="small"
                                variant="outlined"
                                value={
                                    pilDetails.areas.cfa_total === ""
                                        ? ""
                                        : Number.parseFloat(
                                        pilDetails.areas.cfa_total * 10.76391
                                    ).toFixed(2) || ""
                                }
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>Nature of Project:</Typography>
                                    <FormGroup row>
                                        {nature
                                            .filter(
                                                (obj) => obj.code !== "AA" && obj.code !== "OTHERS"
                                            )
                                            .map((a, index) => (
                                                <FormControlLabel
                                                    key={index}
                                                    checked={
                                                        pilDetails.natures.nature.indexOf(a.code) !== -1
                                                    }
                                                    control={
                                                        <Checkbox
                                                            disabled={disabled}
                                                            onClick={() => {
                                                                handleNature(a.code);
                                                            }}
                                                        />
                                                    }
                                                    label={a.value}
                                                />
                                            ))}
                                    </FormGroup>
                                    <FormGroup>
                                        {nature
                                            .filter((obj) => obj.code === "AA")
                                            .map((a, index) => (
                                                <FormControlLabel
                                                    key={index}
                                                    checked={
                                                        pilDetails.natures.nature.indexOf(a.code) !== -1
                                                    }
                                                    control={
                                                        <Checkbox
                                                            disabled={disabled}
                                                            onClick={() => {
                                                                handleNature(a.code);
                                                            }}
                                                        />
                                                    }
                                                    label={a.value}
                                                />
                                            ))}

                                        {pilDetails.natures.nature.indexOf("AA") !== -1 && (
                                            <Box border={1} borderColor={"grey.400"}>
                                                <div style={{margin: "4px"}}>
                                                    <Grid item xs={12}>
                                                        <Tooltip title="Add A&A Works Item">
                                                            <IconButton
                                                                disabled={disabled}
                                                                aria-label="add"
                                                                onClick={addAAWorks}
                                                            >
                                                                <AddCircleIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    {pilDetails.natures.aaworks.map((obj, index) => (
                                                        <Grid container xs={12}>
                                                            <Grid item xs={11}>
                                                                <TextField
                                                                    className={classes.textField}
                                                                    fullWidth={true}
                                                                    disabled={disabled}
                                                                    id={"aad"}
                                                                    name={"aad"}
                                                                    label={"A&A Works Description"}
                                                                    type="text"
                                                                    size="small"
                                                                    variant={textfieldVariant}
                                                                    value={obj.description || ""}
                                                                    onChange={handleAAChanges(index)}
                                                                    InputProps={{
                                                                        readOnly: readOnlyAndDisabled,
                                                                    }}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                <Tooltip title="Delete A&A Items">
                                                                    <IconButton
                                                                        disabled={disabled}
                                                                        aria-label="delete"
                                                                        onClick={() => {
                                                                            deleteAAItems(index);
                                                                        }}
                                                                    >
                                                                        <DeleteIcon/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                    ))}
                                                </div>
                                            </Box>
                                        )}
                                    </FormGroup>
                                    <FormGroup>
                                        {nature
                                            .filter((obj) => obj.code === "OTHERS")
                                            .map((a, index) => (
                                                <FormControlLabel
                                                    key={index}
                                                    checked={
                                                        pilDetails.natures.nature.indexOf(a.code) !== -1
                                                    }
                                                    control={
                                                        <Checkbox
                                                            disabled={disabled}
                                                            onClick={() => {
                                                                handleNature(a.code);
                                                            }}
                                                        />
                                                    }
                                                    label={a.value}
                                                />
                                            ))}
                                        {pilDetails.natures.nature.indexOf("OTHERS") !== -1 && (
                                            <TextField
                                                className={classes.textField}
                                                // fullWidth={true} disabled={disabled}
                                                id={"others"}
                                                name={"others"}
                                                label={"Nature of Project (Others)"}
                                                type="text"
                                                size="small"
                                                variant={textfieldVariant}
                                                value={pilDetails.natures.natureother || ""}
                                                onChange={handleInputChange("natures", "natureother")}
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                }}
                                            />
                                        )}
                                    </FormGroup>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"no_blocks"}
                                name={"no_blocks"}
                                label={"No. of Blocks & Storey"}
                                type="text"
                                multiline
                                rows={3}
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.no_blocks || ""}
                                onChange={handleInputChange("details", "no_blocks")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>No. of Residential Units</Typography>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"tower"}
                                                name={"tower"}
                                                label={"Tower"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>Units</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.tower || ""}
                                                onChange={handleInputChange("general", "tower")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"villa"}
                                                name={"villa"}
                                                label={"Villa"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>Units</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.villa || ""}
                                                onChange={handleInputChange("general", "villa")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"house"}
                                                name={"house"}
                                                label={"House"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.house || ""}
                                                onChange={handleInputChange("general", "house")}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>No. of Carpark</Typography>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"rescarpark"}
                                                name={"rescarpark"}
                                                label={"Residential Carpark"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.rescarpark || ""}
                                                onChange={handleInputChange("general", "rescarpark")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"comcarpark"}
                                                name={"comcarpark"}
                                                label={"Commercial Carpark"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.comcarpark || ""}
                                                onChange={handleInputChange("general", "comcarpark")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"visitorcarpark"}
                                                name={"visitorcarpark"}
                                                label={"Visitor Carpark"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.visitorcarpark || ""}
                                                onChange={handleInputChange(
                                                    "general",
                                                    "visitorcarpark"
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"motor"}
                                                name={"motor"}
                                                label={"Motorcycle"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.motor || ""}
                                                onChange={handleInputChange("general", "motor")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"bicycle"}
                                                name={"bicycle"}
                                                label={"Bicycle"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.bicycle || ""}
                                                onChange={handleInputChange("general", "bicycle")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"loading"}
                                                name={"loading"}
                                                label={"Loading / Unloading Bay"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.loading || ""}
                                                onChange={handleInputChange("general", "loading")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"publicvehicle"}
                                                name={"publicvehicle"}
                                                label={"Public Vehicle Carpark"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.publicvehicle || ""}
                                                onChange={handleInputChange("general", "publicvehicle")}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                className={classes.textField}
                                                fullWidth={true}
                                                disabled={disabled}
                                                id={"lgv"}
                                                name={"lgv"}
                                                label={"LGV/HGV/Coach Parking"}
                                                type="text"
                                                size="small"
                                                InputProps={{
                                                    readOnly: readOnlyAndDisabled,
                                                    endAdornment: <span>No.</span>,
                                                }}
                                                variant={textfieldVariant}
                                                value={pilDetails.general.lgv || ""}
                                                onChange={handleInputChange("general", "lgv")}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"beamplus"}
                                name={"beamplus"}
                                label={"Target Beam Plus/Other Similar Assessments Rating"}
                                type="text"
                                size="small"
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                                variant={textfieldVariant}
                                value={pilDetails.details.target_beam_rating || ""}
                                onChange={handleInputChange("details", "target_beam_rating")}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"beamplus"}
                                name={"beamplus"}
                                label={"Actual Beam Plus/Other Similar Assessments Rating"}
                                type="text"
                                size="small"
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                                variant={textfieldVariant}
                                value={pilDetails.details.actual_beam_rating || ""}
                                onChange={handleInputChange("details", "actual_beam_rating")}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Commencement Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_commencement_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_commencement_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Commencement Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_commencement_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_commencement_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Site Formation Commencement Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_site_form_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_site_form_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Site Formation Commencement Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_site_form_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_site_form_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Cap Commencement Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_cap_form_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_cap_form_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Cap Commencement Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_cap_form_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_cap_form_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Occupation Permit Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_op_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_op_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Occupation Permit Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_op_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_op_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>
                                        Phased Op Date(s)
                                        <Tooltip title="Add Phased Occupation Permit Date">
                                            <IconButton
                                                disabled={disabled}
                                                aria-label="add"
                                                onClick={addPhasedOP}
                                            >
                                                <AddCircleIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Grid container spacing={1}>
                                        {pilDetails.phaseOp
                                            .filter((a) => a.status === "Y")
                                            .map((obj, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        margin: "4px",
                                                        display: "flex",
                                                        width: "100%",
                                                        gap: "8px",
                                                    }}
                                                >
                                                    <Grid item xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                className={classes.textField}
                                                                id={"target"}
                                                                name={"target"}
                                                                label={"Target Date"}
                                                                fullWidth={true}
                                                                disabled={disabled}
                                                                format="dd/MM/yyyy"
                                                                placeholder="DD/MM/YYYY"
                                                                size="small"
                                                                inputVariant={textfieldVariant}
                                                                KeyboardButtonProps={{
                                                                    "aria-label": "change date",
                                                                }}
                                                                value={obj.target_date || null}
                                                                onChange={(date) =>
                                                                    handleAddedDateFieldChange(
                                                                        date,
                                                                        "phaseOp",
                                                                        obj.id,
                                                                        "target_date"
                                                                    )
                                                                }
                                                                InputProps={{
                                                                    readOnly: readOnlyAndDisabled,
                                                                }}
                                                                readOnly={readOnlyAndDisabled}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                className={classes.textField}
                                                                id={"actual"}
                                                                name={"actual"}
                                                                label={"Actual Date"}
                                                                fullWidth={true}
                                                                disabled={disabled}
                                                                format="dd/MM/yyyy"
                                                                placeholder="DD/MM/YYYY"
                                                                size="small"
                                                                inputVariant={textfieldVariant}
                                                                KeyboardButtonProps={{
                                                                    "aria-label": "change date",
                                                                }}
                                                                value={obj.actual_date || null}
                                                                onChange={(date) =>
                                                                    handleAddedDateFieldChange(
                                                                        date,
                                                                        "phaseOp",
                                                                        obj.id,
                                                                        "actual_date"
                                                                    )
                                                                }
                                                                InputProps={{
                                                                    readOnly: readOnlyAndDisabled,
                                                                }}
                                                                readOnly={readOnlyAndDisabled}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Tooltip title="Delete Phased OP Date">
                                                            <IconButton
                                                                disabled={disabled}
                                                                aria-label="delete"
                                                                onClick={() => {
                                                                    deleteDates("phaseOp", obj.id);
                                                                }}
                                                            >
                                                                <DeleteIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </div>
                                            ))}
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Practical Completion Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_practical_com_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_practical_com_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Practical Completion Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_practical_com_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_practical_com_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>
                                        Sectional Completion Date(s)
                                        <Tooltip title="Add Sectional Completion Date(s)">
                                            <IconButton
                                                disabled={disabled}
                                                aria-label="add"
                                                onClick={addSecCom}
                                            >
                                                <AddCircleIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Grid container spacing={1}>
                                        {pilDetails.secCom
                                            .filter((a) => a.status === "Y")
                                            .map((obj, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        margin: "4px",
                                                        display: "flex",
                                                        width: "100%",
                                                        gap: "8px",
                                                    }}
                                                >
                                                    <Grid item xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                className={classes.textField}
                                                                id={"target"}
                                                                name={"target"}
                                                                label={"Target Date"}
                                                                fullWidth={true}
                                                                disabled={disabled}
                                                                format="dd/MM/yyyy"
                                                                placeholder="DD/MM/YYYY"
                                                                size="small"
                                                                inputVariant={textfieldVariant}
                                                                KeyboardButtonProps={{
                                                                    "aria-label": "change date",
                                                                }}
                                                                value={obj.target_date || null}
                                                                onChange={(date) =>
                                                                    handleAddedDateFieldChange(
                                                                        date,
                                                                        "secCom",
                                                                        obj.id,
                                                                        "target_date"
                                                                    )
                                                                }
                                                                InputProps={{
                                                                    readOnly: readOnlyAndDisabled,
                                                                }}
                                                                readOnly={readOnlyAndDisabled}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                className={classes.textField}
                                                                id={"actual"}
                                                                name={"actual"}
                                                                label={"Actual Date"}
                                                                fullWidth={true}
                                                                disabled={disabled}
                                                                format="dd/MM/yyyy"
                                                                placeholder="DD/MM/YYYY"
                                                                size="small"
                                                                inputVariant={textfieldVariant}
                                                                KeyboardButtonProps={{
                                                                    "aria-label": "change date",
                                                                }}
                                                                value={obj.actual_date || null}
                                                                onChange={(date) =>
                                                                    handleAddedDateFieldChange(
                                                                        date,
                                                                        "secCom",
                                                                        obj.id,
                                                                        "actual_date"
                                                                    )
                                                                }
                                                                InputProps={{
                                                                    readOnly: readOnlyAndDisabled,
                                                                }}
                                                                readOnly={readOnlyAndDisabled}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Tooltip title="Delete Phased OP Date">
                                                            <IconButton
                                                                disabled={disabled}
                                                                aria-label="delete"
                                                                onClick={() => {
                                                                    deleteDates("secCom", obj.id);
                                                                }}
                                                            >
                                                                <DeleteIcon/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </div>
                                            ))}
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Consent to Assign Date(CTOA)"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_consent_assign_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_consent_assign_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Consent to Assign Date(CTOA)"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_consent_assign_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_consent_assign_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Certificate of Compliance Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_cc_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_cc_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Certificate of Compliance Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_cc_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_cc_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Target Building Covenant Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.target_bc_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "target_bc_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.textField}
                                    id={"date"}
                                    name={"request_date"}
                                    label={"Actual Building Covenant Date"}
                                    fullWidth={true}
                                    disabled={disabled}
                                    format="dd/MM/yyyy"
                                    placeholder="DD/MM/YYYY"
                                    size="small"
                                    inputVariant={textfieldVariant}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                    value={pilDetails.details.actual_bc_date || null}
                                    onChange={(date) =>
                                        handleDateFieldChange(date, "actual_bc_date")
                                    }
                                    InputProps={{
                                        readOnly: readOnlyAndDisabled,
                                    }}
                                    readOnly={readOnlyAndDisabled}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>Defect Liability Period</Typography>
                                    <FormGroup row>
                                        <RadioGroup
                                            row
                                            value={
                                                pilDetails.details.DEFECT3YEARS === "N" &&
                                                pilDetails.details.DEFECT12 === "N"
                                                    ? ""
                                                    : pilDetails.details.DEFECT3YEARS === "Y"
                                                        ? "DEFECT3YEARS"
                                                        : "DEFECT12"
                                            }
                                            onChange={handleDefectRadioChange}
                                        >
                                            {defect.map((a, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <FormControlLabel
                                                        value={a.code}
                                                        control={<Radio disabled={disabled}/>}
                                                        label={a.value}
                                                    />
                                                </Grid>
                                            ))}
                                        </RadioGroup>
                                    </FormGroup>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"proj_phasing"}
                                name={"proj_phasing"}
                                label={"Project Phasing (if any)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.proj_phasing || ""}
                                onChange={handleInputChange("details", "proj_phasing")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"developer_name"}
                                name={"developer_name"}
                                label={"Name of Developer"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.developer_name || ""}
                                onChange={handleInputChange("details", "developer_name")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"proj_manager"}
                                name={"proj_manager"}
                                label={"Client Project Manager(CPM)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.client_proj_manager || ""}
                                onChange={handleInputChange("details", "client_proj_manager")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"technical_director"}
                                name={"technical_director"}
                                label={"Technical Directory (BD-TD)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.technical_director || ""}
                                onChange={handleInputChange("details", "technical_director")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"authorised_signatory"}
                                name={"authorised_signatory"}
                                label={"Authroised Signatory (BD-AS)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.authorised_signatory || ""}
                                onChange={handleInputChange("details", "authorised_signatory")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"architect"}
                                name={"architect"}
                                label={"Design Architect"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.design_architect || ""}
                                onChange={handleInputChange("details", "design_architect")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"architect"}
                                name={"architect"}
                                label={"Architecture"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.architect || ""}
                                onChange={handleInputChange("details", "architect")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"architectap"}
                                name={"architectap"}
                                label={"Architecture AP(BD-AP)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.architect_ap || ""}
                                onChange={handleInputChange("details", "architect_ap")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"structural_consultant"}
                                name={"structural_consultant"}
                                label={"Structural Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.structural_consultant || ""}
                                onChange={handleInputChange("details", "structural_consultant")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"structural_consultant"}
                                name={"structural_consultant"}
                                label={"Structural Consultant RSE(BD-RSE)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.structuralconsultant_rse || ""}
                                onChange={handleInputChange(
                                    "details",
                                    "structuralconsultant_rse"
                                )}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"me_consultant"}
                                name={"me_consultant"}
                                label={"M&E Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.me_consultant || ""}
                                onChange={handleInputChange("details", "me_consultant")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"geo_consultant"}
                                name={"geo_consultant"}
                                label={"Geotechnical Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.geo_consultant || ""}
                                onChange={handleInputChange("details", "geo_consultant")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"geo_consultant"}
                                name={"geo_consultant"}
                                label={"Geotechnical Consultant RGE (BD-RGE)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.geoconsultant_rge || ""}
                                onChange={handleInputChange("details", "geoconsultant_rge")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"landscape_architect"}
                                name={"landscape_architect"}
                                label={"Landscape Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.landscape_architect || ""}
                                onChange={handleInputChange("details", "landscape_architect")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"interior_designer"}
                                name={"interior_designer"}
                                label={"Interior Designer/Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.interior_designer || ""}
                                onChange={handleInputChange("details", "interior_designer")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"beamplus_consultant"}
                                name={"beamplus_consultant"}
                                label={"Sustainability / BeamPlus Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.beamplus_consultant || ""}
                                onChange={handleInputChange("details", "beamplus_consultant")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"qs_consultant"}
                                name={"qs_consultant"}
                                label={"Quantity Surveying/QS Consultant"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.qs_consultant || ""}
                                onChange={handleInputChange("details", "qs_consultant")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>
                                        Other Consultant(s)
                                        <Tooltip title="Add Other Consultant(s)">
                                            <IconButton
                                                disabled={disabled}
                                                aria-label="add"
                                                onClick={addOtherConsultant}
                                            >
                                                <AddCircleIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Grid container spacing={1}>
                                        {pilDetails.otherConsultant.map((obj, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    margin: "4px",
                                                    display: "flex",
                                                    width: "100%",
                                                    gap: "8px",
                                                }}
                                            >
                                                <Grid item xs={12}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth={true}
                                                        disabled={disabled}
                                                        id={"other_title"}
                                                        name={"other_title"}
                                                        label={"Title"}
                                                        type="text"
                                                        size="small"
                                                        variant={textfieldVariant}
                                                        value={obj.title || ""}
                                                        onChange={handleOtherConsultantChange(
                                                            index,
                                                            "title"
                                                        )}
                                                        InputProps={{
                                                            readOnly: readOnlyAndDisabled,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth={true}
                                                        disabled={disabled}
                                                        id={"other_name"}
                                                        name={"name"}
                                                        label={"Name"}
                                                        type="text"
                                                        size="small"
                                                        variant={textfieldVariant}
                                                        value={obj.name || ""}
                                                        onChange={handleOtherConsultantChange(
                                                            index,
                                                            "name"
                                                        )}
                                                        InputProps={{
                                                            readOnly: readOnlyAndDisabled,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip title="Delete Other Consultant">
                                                        <IconButton
                                                            disabled={disabled}
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                deleteItems(index, "otherConsultant");
                                                            }}
                                                        >
                                                            <DeleteIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </div>
                                        ))}
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"estate_management"}
                                name={"estate_management"}
                                label={"Estate Management"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.estate_management || ""}
                                onChange={handleInputChange("details", "estate_management")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"main_contractor"}
                                name={"main_contractor"}
                                label={"Main Contractor"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.main_contractor || ""}
                                onChange={handleInputChange("details", "main_contractor")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                disabled={disabled}
                id={"con_manager"}
                name={"con_manager"}
                label={"Project Director / Deputy Project Director"}
                size="small"
                variant={textfieldVariant}
                value={pilDetails.details.con_manager || ""}
                onChange={handleInputChange("details", "con_manager")}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                disabled={disabled}
                id={"con_proj_manager"}
                name={"con_proj_manager"}
                label={"Project Manager / Deputy Project Manager"}
                type="text"
                size="small"
                variant={textfieldVariant}
                value={pilDetails.details.con_proj_manager || ""}
                onChange={handleInputChange("details", "con_proj_manager")}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                disabled={disabled}
                id={"site_agent"}
                name={"site_agent"}
                label={"Site Agent"}
                type="text"
                size="small"
                variant={textfieldVariant}
                value={pilDetails.details.site_agent || ""}
                onChange={handleInputChange("details", "site_agent")}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                disabled={disabled}
                id={"proj_coordinator"}
                name={"proj_coordinator"}
                label={"Engineer (Building)"}
                type="text"
                size="small"
                variant={textfieldVariant}
                value={pilDetails.details.proj_coordinator || ""}
                onChange={handleInputChange("details", "proj_coordinator")}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                }}
              />
            </Grid> */}
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"const_control_leader1"}
                                name={"const_control_leader"}
                                label={"Cost Control Leader(Accounting Manager)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.accounting_manager || ""}
                                onChange={handleInputChange("details", "accounting_manager")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"const_control_leader2"}
                                name={"const_control_leader2"}
                                label={"Cost Control Leader(Quantity Surveying Manager)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.quantity_survey_manager || ""}
                                onChange={handleInputChange(
                                    "details",
                                    "quantity_survey_manager"
                                )}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"const_control_leader3"}
                                name={"const_control_leader3"}
                                label={"Cost Control Leader(Contracts Manager)"}
                                type="text"
                                size="small"
                                variant={textfieldVariant}
                                value={pilDetails.details.contracts_manager || ""}
                                onChange={handleInputChange("details", "contracts_manager")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                className={classes.textField}
                                disabled={disabled}
                                id={"full_name"}
                                options={nameList.map((obj) => obj.fullname)}
                                variant={textfieldVariant}
                                value={
                                    (pilDetails.pics[0] && pilDetails.pics[0].full_name) || ""
                                }
                                onChange={(event, value) => {
                                    handlePersonChange(event, 0, "pics", "full_name", value);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        disabled={disabled}
                                        variant={textfieldVariant}
                                        fullWidth
                                        label="Name of PIC (Project in Charge)"
                                        name={"full_name"}
                                        type="text"
                                        size="small"
                                    />
                                )}
                            />
                        </Grid>
                        {/* <Grid item xs={12}>
              <Box border={1} borderColor={"grey.400"}>
                <div style={{ margin: "4px" }}>
                  <Typography>
                    PIC (Project In Charge)
                    <Tooltip title="Add PIC">
                      <IconButton  disabled={disabled}
                        aria-label="add"
                        onClick={() => {
                          addPerson("pics");
                        }}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                  <Grid container spacing={1}>
                    {pilDetails.pics.map((obj, index) => (
                      <div
                        key={index}
                        style={{
                          margin: "4px",
                          display: "flex",
                          width: "100%",
                          gap: "8px",
                        }}
                      >
                        <Grid item xs={12}>
                          <Autocomplete
                            className={classes.textField}
                            id={"full_name"}
                            options={nameList.map((obj) => obj.fullname)}
                            variant={textfieldVariant}
                            value={obj.full_name || ""}
                            onChange={(event, value) => {
                              handlePersonChange(
                                event,
                                index,
                                "pics",
                                "full_name",
                                value
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant={textfieldVariant}
                                fullWidth
                                label="Full Name"
                                name={"full_name"}
                                type="text"
                                size="small"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <Tooltip title="Delete PIC">
                            <IconButton  disabled={disabled}
                              aria-label="delete"
                              onClick={() => {
                                deleteItems(index, "pics");
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </div>
                    ))}
                  </Grid>
                </div>
              </Box>
            </Grid> */}
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <FormControlLabel
                                        checked={enableProjPhasing}
                                        control={
                                            <Checkbox
                                                disabled={disabled}
                                                onClick={() => {
                                                    if (enableProjPhasing) {
                                                        setPilDetails({
                                                            ...pilDetails,
                                                            sics: pilDetails.sics.map((obj) => {
                                                                return {
                                                                    ...obj,
                                                                    proj_phasing: "",
                                                                };
                                                            }),
                                                        });
                                                    }
                                                    setEnableProjPhasing((prev) => !prev);
                                                }}
                                            />
                                        }
                                        label={"Have Project Phasing"}
                                    />
                                    <Typography>
                                        SIC (Site In Charge)
                                        <Tooltip title="Add PIC">
                                            <IconButton
                                                disabled={disabled}
                                                aria-label="add"
                                                onClick={() => {
                                                    addPerson("sics");
                                                }}
                                            >
                                                <AddCircleIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Grid container spacing={1}>
                                        {pilDetails.sics.map((obj, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    margin: "4px",
                                                    display: "flex",
                                                    width: "100%",
                                                    gap: "8px",
                                                }}
                                            >
                                                {enableProjPhasing && (
                                                    <Grid item xs={4}>
                                                        <TextField
                                                            className={classes.textField}
                                                            fullWidth={true}
                                                            disabled={disabled}
                                                            id={"proj_phasing"}
                                                            name={"proj_phasing"}
                                                            label={"Project Phasing"}
                                                            type="text"
                                                            size="small"
                                                            variant={textfieldVariant}
                                                            value={obj.proj_phasing || ""}
                                                            onChange={handleSicChange(
                                                                index,
                                                                "sics",
                                                                "proj_phasing"
                                                            )}
                                                            InputProps={{
                                                                readOnly: readOnlyAndDisabled,
                                                            }}
                                                        />
                                                    </Grid>
                                                )}
                                                <Grid item xs={enableProjPhasing ? 4 : 6}>

                                                    <Autocomplete
                                                        className={classes.textField}
                                                        disabled={disabled}
                                                        id={"full_name"}
                                                        options={nameList.map((obj) => obj.fullname)}
                                                        variant={textfieldVariant}
                                                        value={obj.full_name || ""}

                                                        onChange={(event, value) => {
                                                            handlePersonChange(
                                                                event,
                                                                index,
                                                                "sics",
                                                                "full_name",
                                                                value
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                disabled={disabled}
                                                                variant={textfieldVariant}
                                                                fullWidth
                                                                error={obj.full_name === "" || !obj.full_name}
                                                                label="Full Name"
                                                                name={"full_name"}
                                                                type="text"
                                                                size="small"
                                                            />
                                                        )}
                                                    />


                                                </Grid>
                                                <Grid item xs={enableProjPhasing ? 4 : 6}>
                                                    <Autocomplete
                                                        className={classes.textField}
                                                        disabled={disabled}
                                                        id={"orcl_code"}
                                                        options={projCodeList.map(item => item.project_code)}
                                                        variant={textfieldVariant}
                                                        value={obj.orcl_code || ""}
                                                        onChange={(event, value) => {
                                                            handlePersonChange(
                                                                event,
                                                                index,
                                                                "sics",
                                                                "orcl_code",
                                                                value
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                disabled={disabled}
                                                                variant={textfieldVariant}
                                                                fullWidth
                                                                label="Financial Project Code"
                                                                name={"financial_proj_code"}
                                                                type="text"
                                                                size="small"
                                                            />
                                                        )}
                                                    />
                                                    {/* <TextField
                            className={classes.textField}
                            fullWidth={true}
                            disabled={disabled}
                            id={"financial_proj_code"}
                            name={"financial_proj_code"}
                            label={"Financial Project Code"}
                            type="text"
                            size="small"
                            variant={textfieldVariant}
                            value={obj.orcl_code || ""}
                            onChange={handleSicChange(
                              index,
                              "sics",
                              "orcl_code"
                            )}
                            InputProps={{
                              readOnly: readOnlyAndDisabled,
                            }}
                          />*/}
                                                </Grid>
                                                <Grid item xs={enableProjPhasing ? 4 : 6}>
                                                    <Autocomplete
                                                        className={classes.textField}
                                                        disabled={disabled}
                                                        id={"sub_orcl_code"}
                                                        options={projCodeList.find(item => item.project_code === obj.orcl_code)?.subproject_code || []} //obj.orcl_code
                                                        variant={textfieldVariant}
                                                        value={obj.orcl_sub_code || ""}
                                                        onChange={(event, value) => {
                                                            handlePersonChange(
                                                                event,
                                                                index,
                                                                "sics",
                                                                "orcl_sub_code",
                                                                value
                                                            );
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                disabled={disabled}
                                                                variant={textfieldVariant}
                                                                fullWidth
                                                                label="Financial Sub Project Code"
                                                                name={"financial_sub_proj_code"}
                                                                type="text"
                                                                size="small"
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip title="Delete SIC">
                                                        <IconButton
                                                            disabled={disabled}
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                deleteItems(index, "sics");
                                                            }}
                                                        >
                                                            <DeleteIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </div>
                                        ))}
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>
                                        CPM (Client Project Manager)
                                        <Tooltip title="Add CPM">
                                            <IconButton
                                                disabled={disabled}
                                                aria-label="add"
                                                onClick={() => {
                                                    addPerson("cpms");
                                                }}
                                            >
                                                <AddCircleIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                    <Grid container spacing={1}>
                                        {pilDetails.cpms.map((obj, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    margin: "4px",
                                                    display: "flex",
                                                    width: "100%",
                                                    gap: "8px",
                                                }}
                                            >
                                                <Grid item xs={12}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth={true}
                                                        disabled={disabled}
                                                        id={"full_name"}
                                                        name={"full_name"}
                                                        label={"Full Name"}
                                                        type="text"
                                                        size="small"
                                                        variant={textfieldVariant}
                                                        value={obj.full_name || ""}
                                                        onChange={(event) => {
                                                            handlePersonChange(
                                                                event,
                                                                index,
                                                                "cpms",
                                                                "full_name",
                                                                event.target.value
                                                            );
                                                        }}
                                                        InputProps={{
                                                            readOnly: readOnlyAndDisabled,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        className={classes.textField}
                                                        fullWidth={true}
                                                        disabled={disabled}
                                                        id={"email"}
                                                        name={"email"}
                                                        label={"Email"}
                                                        type="text"
                                                        size="small"
                                                        variant={textfieldVariant}
                                                        value={obj.email || ""}
                                                        onChange={(event) => {
                                                            handlePersonChange(
                                                                event,
                                                                index,
                                                                "cpms",
                                                                "email",
                                                                event.target.value
                                                            );
                                                        }}
                                                        InputProps={{
                                                            readOnly: readOnlyAndDisabled,
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip title="Delete CPM">
                                                        <IconButton
                                                            disabled={disabled}
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                deleteItems(index, "cpms");
                                                            }}
                                                        >
                                                            <DeleteIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                            </div>
                                        ))}
                                    </Grid>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>Type of Contract:</Typography>
                                    <FormGroup>
                                        {contract.map((a, index) => (
                                            <Grid container spacing={1} key={index}>
                                                <Grid item xs={3}>
                                                    <FormControlLabel
                                                        style={{marginTop: "10px"}}
                                                        checked={
                                                            pilDetails.contract[a.code] === "Y" ? true : false
                                                        }
                                                        control={
                                                            <Checkbox
                                                                disabled={disabled}
                                                                onClick={() => {
                                                                    handleCheckBox("contract", a.code);
                                                                }}
                                                            />
                                                        }
                                                        label={a.value}
                                                    />
                                                </Grid>
                                                <Grid item xs={9}>
                                                    {(a.code === "JV" || a.code === "INHOUSE") && (
                                                        <TextField
                                                            className={classes.textField}
                                                            fullWidth={true}
                                                            disabled={disabled}
                                                            id={"costplus"}
                                                            name={"costplus"}
                                                            label={`Cost Plus(Project Markup)`}
                                                            type="text"
                                                            size="small"
                                                            variant={textfieldVariant}
                                                            value={
                                                                a.code === "INHOUSE"
                                                                    ? pilDetails.contract.INCOST
                                                                    : pilDetails.contract.JVCOST
                                                            }
                                                            onChange={handleContractInputChange(a.code)}
                                                            error={
                                                                pilDetails.contract[a.code] === "Y" &&
                                                                getCostPlus(a.code) === ""
                                                                    ? true
                                                                    : false
                                                            }
                                                            helperText={
                                                                pilDetails.contract[a.code] === "Y" &&
                                                                getCostPlus(a.code) === ""
                                                                    ? `Required when ${a.code} is checked`
                                                                    : ``
                                                            }
                                                            InputProps={{
                                                                readOnly: readOnlyAndDisabled,
                                                                endAdornment: <span>%</span>,
                                                            }}
                                                        />
                                                    )}
                                                    {a.code === "OTHER" && (
                                                        <TextField
                                                            className={classes.textField}
                                                            fullWidth={true}
                                                            disabled={disabled}
                                                            id={"others"}
                                                            name={"others"}
                                                            label={"Type of Contract (Others)"}
                                                            type="text"
                                                            size="small"
                                                            variant={textfieldVariant}
                                                            value={pilDetails.contract.OTHERSREMARK || ""}
                                                            onChange={handleContractOtherChange}
                                                            InputProps={{
                                                                readOnly: readOnlyAndDisabled,
                                                            }}
                                                        />
                                                    )}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </FormGroup>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box border={1} borderColor={"grey.400"}>
                                <div style={{margin: "4px"}}>
                                    <Typography>Payment Term:</Typography>
                                    <FormGroup>
                                        {paymentTerm.map((a, index) => (
                                            <Grid container spacing={1} key={index}>
                                                <Grid item xs={3}>
                                                    <FormControlLabel
                                                        style={{marginTop: "10px"}}
                                                        checked={
                                                            pilDetails.paymentTerm[a.code] === "Y"
                                                                ? true
                                                                : false
                                                        }
                                                        control={
                                                            <Checkbox
                                                                disabled={disabled}
                                                                onClick={() => {
                                                                    handleCheckBox("paymentTerm", a.code);
                                                                }}
                                                            />
                                                        }
                                                        label={a.value}
                                                    />
                                                </Grid>
                                                <Grid item xs={9}>
                                                    {a.code === "ARCH" &&
                                                        pilDetails.paymentTerm["ARCH"] === "Y" && (
                                                            <TextField
                                                                className={classes.textField}
                                                                fullWidth={true}
                                                                disabled={disabled}
                                                                id={"period"}
                                                                name={"period"}
                                                                label={"Honouring Period"}
                                                                type="text"
                                                                size="small"
                                                                variant={textfieldVariant}
                                                                value={pilDetails.paymentTerm.PERIOD || ""}
                                                                onChange={handlePeriodChange}
                                                                InputProps={{
                                                                    readOnly: readOnlyAndDisabled,
                                                                    endAdornment: <span>Days</span>,
                                                                }}
                                                            />
                                                        )}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </FormGroup>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.textField}
                                fullWidth={true}
                                disabled={disabled}
                                id={"remark"}
                                name={"remark"}
                                label={"Remark"}
                                type="text"
                                size="small"
                                multiline
                                rows={2}
                                variant={textfieldVariant}
                                value={pilDetails.details.remark || ""}
                                onChange={handleInputChange("details", "remark")}
                                InputProps={{
                                    readOnly: readOnlyAndDisabled,
                                }}
                            />
                        </Grid>
                    </Grid>
                </>
            ) : (
                <Fragment>
                    <br/>
                    <Paper elevation={3} style={{margin: "7px"}}>
                        <div
                            style={{margin: "5px"}}
                            dangerouslySetInnerHTML={{__html: htmlStr}}
                        />
                    </Paper>
                </Fragment>
            )}
        </Fragment>
    );
};

export default PilProjectData;
